import type { GetWishlistItemsEndingTodayCountApiResponse } from 'tradera/state/services/types/webapi-member-generated';
import { createApi } from '@reduxjs/toolkit/query/react';
import { isServer } from 'tradera/utils/nextjs';
import { isomorphicWebApiBaseQuery } from 'tradera/state/services/utils/webapi-base-query';

export enum Tags {
    WISH_LIST_ENDING_TODAY = 'WISH_LIST_ENDING_TODAY'
}
export const wishListItemsEndingTodayApi = createApi({
    reducerPath: 'wishListItemsEndingTodayApi',
    baseQuery: isomorphicWebApiBaseQuery,
    tagTypes: Object.keys(Tags),
    endpoints: (builder) => ({
        getWishlistItemsEndingTodayCount: builder.query<
            GetWishlistItemsEndingTodayCountApiResponse,
            void
        >({
            providesTags: [Tags.WISH_LIST_ENDING_TODAY],
            query: () => {
                const baseUrl = isServer ? '' : '/api/webapi';
                return `${baseUrl}/member/wishlist/endingtodaycount`;
            }
        })
    })
});

export const { useGetWishlistItemsEndingTodayCountQuery, endpoints, util } =
    wishListItemsEndingTodayApi;
